/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1}.radio-container[_ngcontent-%COMP%]{-ms-flex-direction:column;flex-direction:column;margin-left:-10px;margin-right:-10px}.sb-step-sim-type-title[_ngcontent-%COMP%]{font-size:20px;font-weight:700;line-height:24px;margin-bottom:32px;padding:0}.sb-step-sim-type-footer-text[_ngcontent-%COMP%]{font-size:12px;line-height:20px;font-weight:600;text-align:center}"];
export { styles as styles };
